module.exports = __webpack_public_path__ + "img/strap.16acc24e.png";